import React from 'react';
import { Star, Clock } from 'lucide-react';
import { cn } from '@/lib/utils';
import { format } from 'date-fns';
import { sk } from 'date-fns/locale';
import { Task } from '@shared/schema';

interface TaskCardProps {
  task: Task;
  className?: string;
}

export function TaskCard({ task, className }: TaskCardProps) {
  const dueDate = task.dueDate ? new Date(task.dueDate) : null;
  const isOverdue = dueDate ? dueDate < new Date() : false;
  
  return (
    <div 
      className={cn(
        "p-3 rounded-lg border cursor-grab active:cursor-grabbing bg-card/90 backdrop-blur-sm shadow-md hover:shadow-lg transition-colors duration-200 group",
        task.isStarred && "border-l-4 border-l-primary shadow-lg",
        className
      )}
    >
      <div className="flex items-start gap-2">
        {task.isStarred && (
          <Star className="h-4 w-4 text-yellow-500 fill-yellow-500 mt-0.5 flex-shrink-0" />
        )}
        <div className="flex-1 min-w-0">
          <h4 className="font-medium text-sm truncate">{task.title}</h4>
          {dueDate && (
            <div className="flex items-center mt-1 text-xs">
              <Clock className="h-3 w-3 mr-1" />
              <span className={cn(
                "truncate",
                isOverdue && "text-destructive"
              )}>
                {format(dueDate, 'd. MMMM', { locale: sk })}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}